export function restoreSettings() {
  let settings = null;

  try {
    const storedData = localStorage.getItem('settings');

    if (storedData) {
      settings = JSON.parse(storedData);
    }
  } catch (err) {
    // If stored data is not a strigified JSON this might fail,
    // that's why we catch the error
  }

  return settings;
}

export function storeSettings(settings) {
  localStorage.setItem('settings', JSON.stringify(settings));
}

const USER_PREFERENCE_KEYS = [
  'direction',
  'responsiveFontSizes',
  'theme',
  'defaultLogin',
];

function pickUserPreferences(settings = {}) {
  return USER_PREFERENCE_KEYS.reduce((accumulator, key) => {
    if (settings[key] !== undefined && settings[key] !== null && settings[key] !== '') {
      accumulator[key] = settings[key];
    }

    return accumulator;
  }, {});
}

export function mergeSettings(runtimeSettings = {}, storedSettings = {}) {
  const mergedSettings = {
    ...storedSettings,
    ...runtimeSettings,
    ...pickUserPreferences(storedSettings),
  };

  if (runtimeSettings.themes !== undefined) {
    mergedSettings.themes = runtimeSettings.themes;
  } else if (storedSettings.themes !== undefined) {
    mergedSettings.themes = storedSettings.themes;
  }

  if (!mergedSettings.theme) {
    mergedSettings.theme =
      storedSettings.theme ||
      runtimeSettings.theme ||
      runtimeSettings.defaultTheme ||
      null;
  }

  return mergedSettings;
}
